export const numericIdValidator = (value?: string): boolean => {
  if (!value?.trim()) {
    return true;
  }

  return /^[1-9]\d{0,9}$/.test(value.trim());
};

export const emailValidator = (value?: string): boolean => {
  if (!value?.trim()) {
    return true;
  }

  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value.trim());
};

export const commaSeparatedValuesValidator = (
  value: string | undefined,
  validator: (value: string) => boolean
): boolean => {
  if (!value?.trim()) {
    return true;
  }

  return value.split(',').every((item) => {
    const normalizedItem = item.trim();

    return normalizedItem.length > 0 && validator(normalizedItem);
  });
};

export const commaSeparatedNumericIdValidator = (value?: string): boolean =>
  commaSeparatedValuesValidator(value, numericIdValidator);

export const commaSeparatedEmailValidator = (value?: string): boolean =>
  commaSeparatedValuesValidator(value, emailValidator);
